import { createRouter, createWebHistory } from 'vue-router';
import { $fetch } from '@/utils/fetch';
import { ROUTER_BASE_URL } from '../constants';
import { inject, type Ref } from 'vue';
import { useWeChatShare } from '@/utils/wechat-share'
import { useAppStore } from '@/stores/app';

const router = createRouter({
  history: createWebHistory(ROUTER_BASE_URL),

  routes: [
    {
      path: '/',
      component: () => import('../views/home/index.vue'),
      meta: {
      },
    },
    {
      path: '/speaker/index',
      component: () => import('../views/speaker/index.vue'),
      meta: {
        title: '大会嘉宾',
      },
    },
    {
      path: '/picture/index',
      component: () => import('../views/picture/index.vue'),
      meta: {
        title: '生态交流区',
      },
    },
    {
      path: '/schedule/detail/:id',
      name: 'scheduleDetail',
      props: true,
      component: () => import('../views/schedule/detail.vue'),
      meta: {
        lazyStats: true,
      },
    },
    {
      path: '/journalism/index',
      component: () => import('../views/journalism/index.vue'),
      meta: {
        title: '最新资讯',
      },
    },
    {
      path: '/journalism/detail/:id',
      name: 'journalismDetail',
      props: true,
      component: () => import('../views/journalism/detail.vue'),
      meta: {
        lazyStats: true,
      },
    },
  ],

  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            el: to.hash,
            behavior: 'smooth',
          });
        }, 400);
      })
    }
    else if (savedPosition) {
      return savedPosition;
    }
    else {
      return { top: 0 };
    }
  },
})

let timer = 0;

router.beforeEach(async (to) => {
  const loading = inject('app-loading') as Ref<boolean>;

  window.clearTimeout(timer);

  timer = window.setTimeout(() => {
    loading.value = true;
  }, 100);

  const appStore = useAppStore();

  if (to.meta.title !== false) {
    document.title = to.meta.title ? `${to.meta.title} - ${import.meta.env.VITE_SITE_TITLE}` : import.meta.env.VITE_SITE_TITLE;
  }

  if (appStore.config.name) {
    return true;
  }
  else {
    const { isSuccess } = await appStore.fetchConfig();

    if (!isSuccess) {
      // 取不出来社区基本信息，无法进行，只能跳转 404
      location.replace('/404');

      return false;
    }

    return isSuccess;
  }
});

const configureWeChatSDK = async () => {
  try {
    const { isSuccess, data } = await $fetch('/wechat/v1/signature', {
      method: 'post',
      data: {
        url: window.location.href,
      },
    });

    if (isSuccess) {
      window.wx.config({
        debug: false,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.noncestr,
        signature: data.signature,
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
      });
    } else {
      throw new Error('获取签名失败或数据无效');
    }
  } catch (error) {
    console.error('微信SDK配置失败:', error);
  }
};

router.afterEach((to) => {
  window.clearTimeout(timer);

  const loading = inject('app-loading') as Ref<boolean>;

  if (window.wx) {
    const { config } = useAppStore();
    const { setShareData } = useWeChatShare();
    configureWeChatSDK();
    setShareData({ title: config.title, desc: config.subName })
  }

  // 统计埋点
  if (window._oafs) {
    if (to.meta.lazyStats !== true) {
      setTimeout(() => {
        window._oafs.setDefault('pageId', document.title);
        window._oafs.pv();
      });
    }
  }

  loading.value = false;
});

export default router;
